import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminSession } from '../../../lib/adminEmail';

const AdminRoute = ({ children }) => {
  if (!isAdminSession()) {
    return <Navigate to="/main/Dashboard" replace />;
  }
  return children;
};

export default AdminRoute;
